import { createApp } from 'vue'
import App from './App.vue'
import MainRegistrations from './MainRegistrations';
import { loadMessages } from '@progress/kendo-vue-intl';
import { resources } from './resources';

const appContainerId = "app";
var appContainer = document.getElementById(appContainerId);
var categoryId = appContainer?.getAttribute("data-category-id");
var familyId = appContainer?.getAttribute("data-family-id");
var searchTerm = appContainer?.getAttribute("data-search-term");
var accountId = appContainer?.getAttribute("data-account-id");
var accountUserId = appContainer?.getAttribute("data-account-user-id");
var ordersListLite = Boolean(appContainer?.getAttribute("data-orders-list-lite"));
var languageId = appContainer?.getAttribute("data-language-id");
var appSection = appContainer?.getAttribute("data-app-section");
var localizationKey = appContainer?.getAttribute("data-localization-key");
var gtagActionField = appContainer?.getAttribute("data-gtag-action-field");

var appProps = {
    categoryId: categoryId,
    languageId: languageId,
    familyId: familyId,
    appSection: appSection,
    searchTerm: searchTerm,
    accountId: accountId,
    accountUserId: accountUserId,
    ordersListLite: ordersListLite,
    gtagActionField: gtagActionField
};

const itServerMessages = {
    "grid": {
        "pagerInfo": resources[`Pager_Footer_${localizationKey}`],
        "noRecords": resources[`Pager_NoResults_${localizationKey}`]
    }
};

loadMessages(itServerMessages, languageId + 's'); // because default languages seems buggy

const app = createApp(App, appProps);

MainRegistrations.init(app);

app.mount(`#${appContainerId}`);
